import React, { Component } from 'react';
import { Form, FormGroup, SubmitButton } from '../../../../components/Forms/Forms';
import enums from '../../../../constants/enums';
import { Input, Select } from '../../../../components/Forms/fields';
import { Link } from 'react-router-dom';

export class ChannelDetailsView extends Component {
  constructor(props){
    super(props);
    this.toggleEdit = this.toggleEdit.bind(this);
  }
  toggleEdit(e){
    e.preventDefault();
    this.props.toggleEdit();
  }
  render() {
    const {
      channel,
      editing,
      formState,
      channelTypes,
      channelStatus,
      submitForm,
      onFormUpdate,
      toggle,
      expanded,
      isEven,
    } = this.props;

    return (

      <Form element="tbody" state={formState} onSubmit={submitForm} onChange={onFormUpdate}>
        {editing ? (
          <tr className={isEven ? 'even' : 'odd'}>
            <td><Link to={`/workArea/trades/completed?tradeId=${channel.payment.tradeId}`}>{channel.payment.tradeId}</Link></td>
            <td>{channel.payment.type}</td>
            <td>{channel.payment.code} {channel.payment.pin}</td>
            <td>
              <FormGroup>
                <Select name="status" options={channelStatus}/>
              </FormGroup>
            </td>
            <td>{channel.type}</td>
            <td>{channel.value}</td>
            <td>{channel.created}</td>
            <td>
              <FormGroup>
                <Input name="completed" type="date" placeholder="YYYY-MM-DD"/>
              </FormGroup>
            </td>
            <td>
              <FormGroup>
                <Input name="orderNumber" type="text"/>
              </FormGroup>
            </td>
            <td>
              <FormGroup>
                <Input name="email" type="text"/>
              </FormGroup>
            </td>
            <td>
              <div className="action-buttons">
                <button type="button" onClick={this.toggleEdit}><i className="fi-x size-18"></i> Cancel</button>
                <SubmitButton><i className="fi-save size-18"></i> Save</SubmitButton>
              </div>
            </td>
          </tr>
        ) : (
          <tr key={channel._id} className={ isEven ? 'even' : 'odd'}>
            <td><Link to={`/workArea/trades/completed?tradeId=${channel.payment.tradeId}`}>{channel.payment.tradeId}</Link></td>
            <td>{channel.payment.type}</td>
            <td>{channel.payment.code} {channel.payment.pin}</td>
            <td>{(enums.salesChannelStatusMap[channel.status] || {}).label}</td>
            <td>{channel.type}</td>
            <td>{channel.value}</td>
            <td>{channel.created}</td>
            <td>{channel.completed}</td>
            <td>{channel.orderNumber}</td>
            <td>{channel.email}</td>
            <td>
              <div className="action-buttons">
                <button type="button" onClick={this.toggleEdit}><i className="fi-pencil size-18"></i> Edit</button>
              </div>
            </td>
          </tr>
        )}

        {expanded &&(
          <tr className="expanded-trade">
            <td colSpan="10">
              <div className="channel-details">

                <div className="form-details">

                  <div className="channel-actions">
                    {editing ? (
                      <span>
                        <button className="button" type="button" onClick={this.toggleEdit}>Cancel</button>
                        <SubmitButton className="button">Save</SubmitButton>
                      </span>
                    ) : (
                      <span>
                        <button className="button" type="button" onClick={this.toggleEdit}>Edit</button>
                      </span>
                    )}
                  </div>


                </div>
              </div>
            </td>
          </tr>
        )}
      </Form>

    );
  }

}

export default ChannelDetailsView;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Channels/ChannelDetails/ChannelDetails.view.js